
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1565',
  depVersions: {
  "customer-portal-app": "static-1.1565",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.443",
  "data-fetching-client": "static-1.9409",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24550",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5323",
  "hs-test-utils": "static-1.7722",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9308",
  "hubspot-dlb": "static-2.1786",
  "hubspot-prosemirror": "static-1.17434",
  "hubspot-url-utils": "static-1.3873",
  "HubStyleTokens": "static-2.11154",
  "I18n": "static-7.1553",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6192",
  "payment-link-components": "static-1.22764",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6628",
  "quartz-core": "static-1.5847",
  "react": "static-7.176",
  "react-colorpicker": "static-2.9944",
  "react-dlb": "static-1.70",
  "react-utils": "static-2.5113",
  "rich-text-lib": "static-1.19352",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17500",
  "ui-components-test-utils": "static-1.5292",
  "UIComponents": "static-3.8101",
  "foundations-assets": "static-1.4564",
  "foundations-components": "static-1.7380",
  "foundations-theming": "static-1.4138",
  "foundations-theming-specialty": "static-1.1854",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9346",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.462",
  "quartz-config": "static-1.406",
  "quartz-routing": "static-1.58",
  "quick-fetch": "static-1.3668",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16367",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7872",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4481",
  "ui-addon-react-router-dom": "static-1.9279",
  "usage-tracker": "static-1.7066",
  "usage-tracker-anonymous": "static-1.5483",
  "usage-tracker-core": "static-1.6916",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3166",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2905",
  "quartz-webpack": "static-1.2852",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "customer-data-objects": "static-1.7357",
  "frontend-preferences-client": "static-1.7658",
  "laboratory-lib": "static-3.6880",
  "onboarding-scopes": "static-1.6180",
  "rpc-client-utils": "static-1.4345",
  "ui-addon-opt": "static-4.8120",
  "HeadJS": "static-2.699",
  "hs-test-utils-bend-plugin": "static-1.2833",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3843",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7357",
  "cssUtils": "static-1.712",
  "customer-data-ui-utilities": "static-1.9557",
  "HubStyle": "static-2.11462",
  "knowledge-content-types": "static-1.8298",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.303",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.482",
  "ui-addon-emoji-picker": "static-1.9622",
  "ui-addon-i18n": "static-1.10862",
  "ui-business-units-lib": "static-1.8754",
  "ui-shepherd-react": "static-3.9876",
  "video-components-external": "static-1.10365",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4063",
  "commerce-tours-lib": "static-1.5617",
  "customer-data-properties": "static-1.50585",
  "getting-started-shared-tasks": "static-1.17709",
  "growth-onboarding-reliability": "static-1.4821",
  "onboarding-tours": "static-1.16174",
  "reference-resolvers-lite": "static-1.7823",
  "sales-checkout-service-client": "static-1.3426",
  "ui-addon-iframeable": "static-1.8757",
  "user-context": "static-1.4827",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.781",
  "hubspotter-http": "static-1.4417",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.472",
  "quartz-auth": "static-1.303",
  "quartz-head": "static-1.293",
  "quartz-test": "static-1.303",
  "usage-tracker-container": "static-1.7056",
  "ui-fonts": "static-1.416",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9159",
  "data-token-picker": "static-1.15946",
  "FileManagerLib": "static-1.38346",
  "property-translator": "static-1.5146",
  "atom": "static-1.4803",
  "merchandise-lib": "static-1.256",
  "purchase-motions-components": "static-1.5373",
  "salesImages": "static-1.519",
  "self-service-api": "static-1.9966",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4240",
  "foundations-components-test-utils": "static-1.4863",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1073",
  "bend-plugin-foundations-components": "static-1.3649",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.1022",
  "bend-plugin-foundations-theming": "static-1.2621",
  "foundations-theming-base": "static-1.3123",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4207",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2867",
  "inbound-db-properties-service-client": "static-1.3617",
  "superstore": "static-1.4504",
  "feedback-loader": "static-1.28739",
  "ai-components-ui-library": "static-1.8185",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27777",
  "sassPrefix": "static-1.150",
  "react-dnd-compat": "static-1.4356",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2203",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7892",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4381",
  "content-media-composition-data-lib": "static-1.11231",
  "content-media-compositions": "static-2.15238",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3887",
  "magpie-lib": "static-1.5312",
  "magpie-types": "static-1.4772",
  "media-bridge-lib": "static-1.18468",
  "video-data-lib": "static-1.34023",
  "commerce-products-lib": "static-1.8666",
  "crm-message-bus": "static-1.42167",
  "growth-data-modal": "static-1.5071",
  "hubspot-apollo-client": "static-1.4612",
  "onboarding-tours-client": "static-1.4388",
  "calling-global-api": "static-1.63466",
  "calling-internal-common": "static-1.31024",
  "calling-lifecycle-internal": "static-1.64848",
  "calling-lifecycle-messages": "static-1.57142",
  "conditional-properties-service-client": "static-1.3562",
  "crm-links": "static-1.5984",
  "customer-data-objects-ui-components": "static-1.12735",
  "customer-data-property-utils": "static-1.7804",
  "external-options-client-types": "static-1.3922",
  "file-manager-components": "static-1.22706",
  "framework-data-schema-resolvers": "static-1.6601",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.399",
  "inbound-db-meta-service-client": "static-1.3397",
  "inbounddb-objects-service-types": "static-1.3989",
  "meetings-icalendar-utils-lib": "static-1.366",
  "multi-currency-client-types": "static-1.3457",
  "object-builder-ui-client": "static-1.47773",
  "pipeline-validation-client-types": "static-1.3726",
  "property-value-citations": "static-1.1199",
  "pulse": "static-1.232",
  "smart-property-lib": "static-1.5668",
  "tiered-pricing": "static-1.727",
  "ui-addon-form-validation": "static-1.10727",
  "growth-onboarding-confetti": "static-1.2788",
  "growth-onboarding-next-action-utils": "static-1.1227",
  "navigation-components": "static-1.17078",
  "onboarding-tours-utils": "static-1.240",
  "ui-shepherd-tracker": "static-1.7257",
  "ui-universal-auth": "static-1.8608",
  "batch-promise": "static-1.1267",
  "navigation-messaging": "static-1.6405",
  "getting-started-shared-tasks-store": "static-1.16827",
  "hubspotter-http-shared-msw-handlers": "static-1.9306",
  "audio-components": "static-1.5521",
  "FileManagerCore": "static-1.38205",
  "FileManagerImages": "static-1.35857",
  "video-components": "static-1.12368",
  "growth-monetization-service-types": "static-1.4256",
  "nav-client-types": "static-1.2068",
  "purchase-motions-api": "static-1.5376",
  "signup-constants": "static-1.18264",
  "signup-ui-url-generator": "static-2.7773",
  "trials-service-types": "static-1.3657",
  "chatspot-core": "static-1.20084",
  "chirp-fetch": "static-1.1614",
  "ContentUtils": "static-1.67441",
  "copilot-toolkit": "static-1.10370",
  "growth-onboarding-feedback-components": "static-1.6318",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.458",
  "simple-logging-lib": "static-1.2783",
  "customer-data-tracking": "static-1.6598",
  "products-iframe-lib": "static-1.7159",
  "products-ui-components-shared-msw-handlers": "static-1.9690",
  "hubspot-apollo-cache": "static-1.71",
  "calling-error-reporting": "static-1.31030",
  "shared-worker-versioning": "static-1.10753",
  "calling-usage-tracker": "static-1.6271",
  "voice-sms-access-library": "static-1.52",
  "conversations-skeleton-state": "static-1.6981",
  "location-customization-utils-lib": "static-1.8362",
  "crm-pipelines-api-client-types": "static-1.3903",
  "framework-builder-read-service-client": "static-1.3786",
  "framework-data-schema-quick-fetch": "static-1.6506",
  "persist-promise": "static-1.3424",
  "directed-graph": "static-1.668",
  "event-emitter": "static-1.663",
  "breeze-intelligence-kit": "static-1.5227",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9391",
  "fsm": "static-1.3464",
  "policy-lib": "static-1.6532",
  "react-tinymce": "static-1.54455",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9454",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53581",
  "tinymce-plugins": "static-1.56695",
  "tinymce-themes": "static-1.55551",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4265",
  "video-embed": "static-1.34857",
  "content-icons-ui": "static-1.2132",
  "social-insights-client-types": "static-1.21166",
  "eligibility-engine-service-types": "static-1.2938",
  "chatspot-client-types": "static-1.10396",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4539",
  "integrations-lib": "static-1.15216",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4026",
  "calling-orchestration-schema": "static-1.34829",
  "crm-record-cards-service-types": "static-1.3390",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4254",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2777",
  "interframe": "static-3.4524",
  "tinymce-data": "static-1.39666",
  "ui-addon-sales-email": "static-1.4945",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11923",
  "layout-dnd-utils": "static-1.10898",
  "react-codemirror": "static-1.10343",
  "ui-brand-identity-lib": "static-1.13556",
  "NamespacedHubStyle": "static-2.8836",
  "outpost": "static-1.3942",
  "flux-actions": "static-1.302",
  "integrations-error-boundary-lib": "static-1.12631",
  "integrations-tracking-lib": "static-1.5316",
  "native-integrations-shared-strings": "static-1.7521",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10105",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67516",
  "layout-data-lib": "static-1.9223",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2730",
  "advanced-menus-core": "static-1.14710",
  "advanced-menus-lib": "static-1.11699",
  "ExportDialog": "static-6.10119",
  "ui-memberships-settings-lib": "static-1.33259",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14709",
  "simple-menus-lib": "static-1.16226"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1565",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.443",
  "data-fetching-client": "/data-fetching-client/static-1.9409",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24550",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5323",
  "hs-test-utils": "/hs-test-utils/static-1.7722",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9308",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17434",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyleTokens": "/HubStyleTokens/static-2.11154",
  "I18n": "/I18n/static-7.1553",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6192",
  "payment-link-components": "/payment-link-components/static-1.22764",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6628",
  "quartz-core": "/quartz-core/static-1.5847",
  "react": "/react/static-7.176",
  "react-colorpicker": "/react-colorpicker/static-2.9944",
  "react-dlb": "/react-dlb/static-1.70",
  "react-utils": "/react-utils/static-2.5113",
  "rich-text-lib": "/rich-text-lib/static-1.19352",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17500",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5292",
  "UIComponents": "/UIComponents/static-3.8101",
  "foundations-assets": "/foundations-assets/static-1.4564",
  "foundations-components": "/foundations-components/static-1.7380",
  "foundations-theming": "/foundations-theming/static-1.4138",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1854",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9346",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.462",
  "quartz-config": "/quartz-config/static-1.406",
  "quartz-routing": "/quartz-routing/static-1.58",
  "quick-fetch": "/quick-fetch/static-1.3668",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16367",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7872",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4481",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9279",
  "usage-tracker": "/usage-tracker/static-1.7066",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5483",
  "usage-tracker-core": "/usage-tracker-core/static-1.6916",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3166",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2905",
  "quartz-webpack": "/quartz-webpack/static-1.2852",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "customer-data-objects": "/customer-data-objects/static-1.7357",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7658",
  "laboratory-lib": "/laboratory-lib/static-3.6880",
  "onboarding-scopes": "/onboarding-scopes/static-1.6180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4345",
  "ui-addon-opt": "/ui-addon-opt/static-4.8120",
  "HeadJS": "/HeadJS/static-2.699",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2833",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3843",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7357",
  "cssUtils": "/cssUtils/static-1.712",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9557",
  "HubStyle": "/HubStyle/static-2.11462",
  "knowledge-content-types": "/knowledge-content-types/static-1.8298",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.303",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9622",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10862",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8754",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9876",
  "video-components-external": "/video-components-external/static-1.10365",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4063",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5617",
  "customer-data-properties": "/customer-data-properties/static-1.50585",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17709",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4821",
  "onboarding-tours": "/onboarding-tours/static-1.16174",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7823",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8757",
  "user-context": "/user-context/static-1.4827",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.781",
  "hubspotter-http": "/hubspotter-http/static-1.4417",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.472",
  "quartz-auth": "/quartz-auth/static-1.303",
  "quartz-head": "/quartz-head/static-1.293",
  "quartz-test": "/quartz-test/static-1.303",
  "usage-tracker-container": "/usage-tracker-container/static-1.7056",
  "ui-fonts": "/ui-fonts/static-1.416",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9159",
  "data-token-picker": "/data-token-picker/static-1.15946",
  "FileManagerLib": "/FileManagerLib/static-1.38346",
  "property-translator": "/property-translator/static-1.5146",
  "atom": "/atom/static-1.4803",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "purchase-motions-components": "/purchase-motions-components/static-1.5373",
  "salesImages": "/salesImages/static-1.519",
  "self-service-api": "/self-service-api/static-1.9966",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4240",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4863",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1073",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3649",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.1022",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2621",
  "foundations-theming-base": "/foundations-theming-base/static-1.3123",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4207",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3617",
  "superstore": "/superstore/static-1.4504",
  "feedback-loader": "/feedback-loader/static-1.28739",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8185",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27777",
  "sassPrefix": "/sassPrefix/static-1.150",
  "react-dnd-compat": "/react-dnd-compat/static-1.4356",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2203",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7892",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4381",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11231",
  "content-media-compositions": "/content-media-compositions/static-2.15238",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3887",
  "magpie-lib": "/magpie-lib/static-1.5312",
  "magpie-types": "/magpie-types/static-1.4772",
  "media-bridge-lib": "/media-bridge-lib/static-1.18468",
  "video-data-lib": "/video-data-lib/static-1.34023",
  "commerce-products-lib": "/commerce-products-lib/static-1.8666",
  "crm-message-bus": "/crm-message-bus/static-1.42167",
  "growth-data-modal": "/growth-data-modal/static-1.5071",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4612",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4388",
  "calling-global-api": "/calling-global-api/static-1.63466",
  "calling-internal-common": "/calling-internal-common/static-1.31024",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64848",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57142",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3562",
  "crm-links": "/crm-links/static-1.5984",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12735",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7804",
  "external-options-client-types": "/external-options-client-types/static-1.3922",
  "file-manager-components": "/file-manager-components/static-1.22706",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6601",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.399",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3989",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.366",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3457",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47773",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3726",
  "property-value-citations": "/property-value-citations/static-1.1199",
  "pulse": "/pulse/static-1.232",
  "smart-property-lib": "/smart-property-lib/static-1.5668",
  "tiered-pricing": "/tiered-pricing/static-1.727",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10727",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2788",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1227",
  "navigation-components": "/navigation-components/static-1.17078",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.240",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7257",
  "ui-universal-auth": "/ui-universal-auth/static-1.8608",
  "batch-promise": "/batch-promise/static-1.1267",
  "navigation-messaging": "/navigation-messaging/static-1.6405",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16827",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9306",
  "audio-components": "/audio-components/static-1.5521",
  "FileManagerCore": "/FileManagerCore/static-1.38205",
  "FileManagerImages": "/FileManagerImages/static-1.35857",
  "video-components": "/video-components/static-1.12368",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4256",
  "nav-client-types": "/nav-client-types/static-1.2068",
  "purchase-motions-api": "/purchase-motions-api/static-1.5376",
  "signup-constants": "/signup-constants/static-1.18264",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7773",
  "trials-service-types": "/trials-service-types/static-1.3657",
  "chatspot-core": "/chatspot-core/static-1.20084",
  "chirp-fetch": "/chirp-fetch/static-1.1614",
  "ContentUtils": "/ContentUtils/static-1.67441",
  "copilot-toolkit": "/copilot-toolkit/static-1.10370",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6318",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.458",
  "simple-logging-lib": "/simple-logging-lib/static-1.2783",
  "customer-data-tracking": "/customer-data-tracking/static-1.6598",
  "products-iframe-lib": "/products-iframe-lib/static-1.7159",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9690",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.71",
  "calling-error-reporting": "/calling-error-reporting/static-1.31030",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10753",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6271",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.52",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6981",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8362",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3903",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3786",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6506",
  "persist-promise": "/persist-promise/static-1.3424",
  "directed-graph": "/directed-graph/static-1.668",
  "event-emitter": "/event-emitter/static-1.663",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5227",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9391",
  "fsm": "/fsm/static-1.3464",
  "policy-lib": "/policy-lib/static-1.6532",
  "react-tinymce": "/react-tinymce/static-1.54455",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9454",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53581",
  "tinymce-plugins": "/tinymce-plugins/static-1.56695",
  "tinymce-themes": "/tinymce-themes/static-1.55551",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4265",
  "video-embed": "/video-embed/static-1.34857",
  "content-icons-ui": "/content-icons-ui/static-1.2132",
  "social-insights-client-types": "/social-insights-client-types/static-1.21166",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2938",
  "chatspot-client-types": "/chatspot-client-types/static-1.10396",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4539",
  "integrations-lib": "/integrations-lib/static-1.15216",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4026",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34829",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3390",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4254",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2777",
  "interframe": "/interframe/static-3.4524",
  "tinymce-data": "/tinymce-data/static-1.39666",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4945",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11923",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10898",
  "react-codemirror": "/react-codemirror/static-1.10343",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13556",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8836",
  "outpost": "/outpost/static-1.3942",
  "flux-actions": "/flux-actions/static-1.302",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12631",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5316",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7521",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10105",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67516",
  "layout-data-lib": "/layout-data-lib/static-1.9223",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2730",
  "advanced-menus-core": "/advanced-menus-core/static-1.14710",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11699",
  "ExportDialog": "/ExportDialog/static-6.10119",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33259",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14709",
  "simple-menus-lib": "/simple-menus-lib/static-1.16226"
}
};
